<div class="grid grid--va-middle">
  <div class="grid grid--va-middle">
    <div class="grid__box grid__box--size-min">
      <span class="title tickets-grs-filter__title"> Массов. действия </span>
    </div>
    <div class="grid__box grid__box--size-min">
      <div class="grid grid--gap-8 grid--va-middle">
        <div class="grid__box grid__box--size-min">
          <app-combobox
            [items]="ticketsMultipleAssign.brigades"
            (callback)="ticketsMultipleAssign.onChangeBrigadeForAssigment($event)"
            [textKey]="'brigade_name_merged'"
            [defaultText]="'Выберите бригаду'"
            [initBy]="ticketsMultipleAssign.brigadeSelected"
            [name]="'brigadeNameAssign'"
          ></app-combobox>
        </div>
      </div>
    </div>
    <div class="grid__box grid__box--size-min">
      <div class="grid grid--va-middle grid--gap-8">
        <div class="grid__box grid__box--size-min">
          <span class="title tickets-grs-filter__title">Назначить на</span>
        </div>
        <div class="grid__box grid__box--size-min">
          <div style="width: 100px">
            <app-field>
              <app-select
                [items]="ticketsCurrentFilter.assignDaysList"
                (callback)="ticketsCurrentFilter.changeDayForAssigment($event)"
                [textKey]="'name'"
                [defaultText]="'Выберите тип'"
                [initBy]="ticketsCurrentFilter.assignDaySelected"
                [name]="'ticketsTypeName'"
              ></app-select>
            </app-field>
          </div>
        </div>
        <div class="grid__box grid__box--size-min">
          <button
            class="button"
            type="button"
            id="appAssignBrigade"
            (click)="ticketsMultipleAssign.onAddTicketsToBrigades()"
            [disabled]="!ticketsMultipleAssign.brigadeSelected || !ticketsMultipleAssign.isExistCheckedTicket"
          >
            Назначить
          </button>
        </div>
      </div>
    </div>
    <div class="grid__box grid__box--size-min">
      <div class="vertical-separate"></div>
    </div>
    <div class="grid__box grid__box--size-min">
      <button
        type="button"
        class="button"
        [disabled]="(brigadeAssign && brigadeAssign.brigades && !brigadeAssign.brigades.length) || brigadeAssign?.isAssignedLoading"
        (click)="assignBrigades()"
      >
        Отправить в работу
      </button>
    </div>
    <div class="grid__box grid__box--size-min">
      <div
        class="grid__box grid__box--size-min"
        *ngIf="brigadeAssign && brigadeAssign.brigades && brigadeAssign.brigades.length && !brigadeAssign?.isAssignedSuccess && !brigadeAssign?.isAssignedLoading"
      >
        <span class="text-italic color-gray-dark">
          Заявки на отправку:
          {{ brigadeAssign && brigadeAssign.brigades && brigadeAssign.brigades.length }}
        </span>
      </div>
    </div>
  </div>
  <div class="grid__box grid__box--pull-right grid__box--flex grid__box--justify-content-flex-end">
    <div class="grid grid--va-middle">
      <div class="grid__box grid__box--size-min">
        <a class="link link--dotted" (click)="onResetCheckedTickets()">Снять выделение с заявок </a>
      </div>
      <div class="grid__box grid__box--pull-right grid__box--flex grid__box--justify-content-flex-end">
        <div class="grid grid--va-middle">
          <div class="grid__box grid__box--size-min">
            <div class="grid grid--va-middle grid--gap-4">
              <div class="grid__box grid__box--size-min">
                <app-icon [glyph]="'update'" [size]="'16'" [class]="'icon--va-middle'" [color]="'gray-dark'"></app-icon>
              </div>
              <div class="grid__box grid__box--size-min">
                <a class="link link--dotted-blue-dark" (click)="ticketsListRefresh()">Обновить список заявок</a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="grid__box grid__box--size-min">
        <div class="grid grid--gap-4 grid--va-middle">
          <div class="grid__box grid__box--size-min tickets-grs-filter__icon" (click)="onChangeMode('table')">
            <app-icon [glyph]="'list'" [size]="'20'" [class]="'cur-pointer'" [color]="ticketsCurrentFilter.mode === 'matrix' ? 'gray-dark' : 'blue-dark'"></app-icon>
          </div>
          <div class="grid__box grid__box--size-min tickets-grs-filter__icon" [class.tickets-grs-filter__icon--disabled]="isGRSUser()" (click)="onChangeMode('matrix')">
            <app-icon [glyph]="'cards'" [size]="'20'" [class]="'cur-pointer'" [color]="ticketsCurrentFilter.mode === 'table' ? 'gray-dark' : 'blue-dark'"></app-icon>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<hr class="horizontal-separate tickets-grs-filter__separator" />

<div class="grid grid--va-middle tickets-grs-filter__checkbox-list">
  <app-checkbox *ngFor="let typeGP of ticketsPeriodFilter.appliedTypeGPs" class="tickets-grs-filter__checkbox">
    <input type="checkbox" [checked]="isChecked(typeGP)" (change)="handleChange(typeGP, $event)" />
    <checkbox-text>{{ typeGP.name }}</checkbox-text>
  </app-checkbox>
</div>

<div class="grid grid--va-middle mt-16">
  <app-field>
    <label>Подтип ГП</label>
    <app-select-multiple
      [initBy]="ticketsPeriodFilter.appliedSubtypeGPSelected"
      [initByKey]="'id'"
      [items]="ticketsPeriodFilter.appliedSubtypeGPs"
      [textKey]="'subtype'"
      [defaultText]="'Выберите подтип'"
      (callback)="onChangeSubtypeGPs($event)"
    ></app-select-multiple>
  </app-field>
</div>

<div class="grid grid--va-middle mt-16 tickets-grs-filter__current-filter-types mb-8">
  <a class="link link--dotted-blue-dark" (click)="onChangeTicketType('all')"> Всего ({{ ticketsCurrentFilter.currentFilterTypes?.all?.counts }}) </a>
  <a class="link link--dotted-blue-dark" (click)="onChangeTicketType('opened')"> Открытые ({{ ticketsCurrentFilter.currentFilterTypes?.opened?.counts }}) </a>
  <a
    class="link link--dotted-blue-dark"
    [ngClass]="{
      'link--dotted-blue-dark': ticketsCurrentFilter.currentFilterTypes?.unassigned?.counts === 0,
      'link--dotted-red-dark': $safeNavigationMigration(ticketsCurrentFilter.currentFilterTypes?.unassigned?.counts) > 0
    }"
    (click)="onChangeTicketType('unassigned')"
  >
    Выезд не назначен ({{ ticketsCurrentFilter.currentFilterTypes?.unassigned?.counts }})
  </a>
  <a class="link link--dotted-red-dark" (click)="onChangeTicketType('needActions')"> Требуют действий ({{ ticketsCurrentFilter.currentFilterTypes?.needActions?.counts }}) </a>
</div>
